export const LOGIN = "login";
export const OPERATION_HOME = "operation_home"

export const GET_LOGIN_BY_ID = "get_login_by_id";
